module.exports = __webpack_public_path__ + "dashboard/img/calendar.c231971b8a2984e539aeb30ac406b0b9.svg";